<template>
  <v-card
    outlined
    id="help"
    :elevation="$vuetify.breakpoint.mdAndUp ? 0 : 0"
    :tile="$vuetify.breakpoint.mdAndUp ? false : true"
  >
    <v-row dense justify="space-around" justify-md="space-between">
      <v-col cols="auto" class="mx-3 mb-0">
        <h3 class="title-l font-weight-bold pa-3 pb-0 my-2">
          <v-icon color="secondary" class="mr-2">fas fa-life-ring</v-icon>From
          the Library
        </h3>
      </v-col>
    </v-row>

    <v-row dense v-if="!helpNotReady">
      <v-col class="px-3">
        <p class="px-3">
          Find below some resources that might be useful to you. These are hand
          picked by us and personalized for you based on your preferences.
        </p>
        <p
          class="px-3"
          v-if="
            weekData.additional_info &&
              weekData.additional_info.libraryPicks &&
              weekData.additional_info.libraryPicks.length > 0
          "
        >
          <i>
            <b>Note</b>: You can rate each item using the icons below them.
          </i>
        </p>
      </v-col>
    </v-row>
    <v-card-text class="pt-0">
      <v-row justify="space-around">
        <v-col cols="12" v-if="isLoading" class="text-center">
          <v-progress-circular
            :size="70"
            :width="7"
            color="primary"
            class="mt-7"
            indeterminate
            style
          ></v-progress-circular>
        </v-col>

        <HelpItem
          v-else-if="!isLoading && !helpNotReady"
          v-for="(help, index) in helpItems"
          :key="index"
          :help="help"
        />
        <v-col v-else>
          <p>
            We've changed the way we filter our library items to make it more
            accurate and personalised for each user. You'll have your own list
            of curated items soon 😊
          </p>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
import {mapState, mapGetters} from 'vuex'
import HelpItem from '@/components/currentWeekView/HelpItem'
export default {
  components: {
    HelpItem,
  },
  data() {
    return {
      isLoading: true,
      helpNotReady: false,
      filterBy: '',
      sortBy: '',
      randomSortAttributes: ['rating', 'name'],
      defaultLimit: '&_limit=3',
    }
  },

  computed: {
    ...mapGetters(['helpItems', 'weekData']),
  },
  mounted() {
    if (
      !this.weekData.id ||
      (this.weekData &&
        this.weekData.additional_info &&
        this.weekData.additional_info.libraryPicks &&
        this.weekData.additional_info.libraryPicks.length > 0)
    ) {
      this.loadHelp()
    } else {
      this.helpNotReady = true
      this.isLoading = false
    }
  },
  created() {
    // console.log('Help component created')
  },
  methods: {
    loadHelp() {
      this.$store
        .dispatch('getHelpForWeek', {week: this.weekData.id || 'default'})
        .then(resources => {
          this.isLoading = false
        })
        .catch(err => {
          this.isLoading = false
        })
    },
    loadWelcometHelp() {
      this.$store
        .dispatch('getWelcomeHelp')
        .then(() => {
          this.isLoading = false
        })
        .catch(err => {
          this.isLoading = false
        })
    },
  },
}
</script>

<style></style>
